export enum typeNotification {
    ANSWER = 'R',
    VIEWED = 'V',
    DELETE = 'D',
    STATE = 'E',
    NOTIFY = 'N'
}
